import classNames from "classnames"
import Link from "next/link"
import { PureComponent } from "react"
import ReactCSSTransitionGroup from "react-addons-css-transition-group"
import ReactMarkdown from "react-markdown"

import AddUser from "../../components/add-user/add-user"
import PremiumBadge from "../../components/premium-badge/premium-badge"
import ProfilePic from "../../components/profile-pic/profile-pic"
import SendMessage from "../../components/send-message/send-message"
import Tag from "../../components/tag/tag"
import customRendererLink from "../../utils/custom-link-renderer"

import gql from "graphql-tag"
import { Mutation } from "react-apollo"
import Cta from "../../components/cta/cta"
import { SAVE_IDEA } from "../../components/ideas/ideasCards"
import ROLE from "../../utils/constant"
import "./additional-details.scss"

const WHY_MAKE_GOOD_COFOUNDER = "WHY_MAKE_GOOD_COFOUNDER"
const ELEVATOR_PITCH_FOR_STARTUP = "ELEVATOR_PITCH_FOR_STARTUP"
const UPDATE_IDEAS_LIKES = gql`
  mutation TOGGLE_LIKE_IDEA($ideaId: ID!) {
    toggleLikeIdea(ideaId: $ideaId) {
      id
      likes {
        id
        user {
          id
        }
      }
    }
  }
`
const TOGGLE_COMMENT_LIKES = gql`
  mutation TOGGLE_COMMENT_LIKES($commentId: ID!) {
    toggleCommentLikes(commentId: $commentId) {
      id
      totalLikes
      likes {
        id
        user {
          id
        }
      }
      replies {
        id
        totalLikes
        likes {
          id
          user {
            id
          }
        }
      }
    }
  }
`
class AdditionalDetails extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      tab: props.hasIdeaForStartup
        ? "ELEVATOR_PITCH_FOR_STARTUP"
        : "WHY_MAKE_GOOD_COFOUNDER",
    }
  }

  setTab = (tab) => {
    this.setState({
      tab,
    })
  }

  render() {
    const {
      whyMakeGoodCofounder,
      lookingToJoinStartupAsFounder,
      hasIdeaForStartup,
      elevatorPitchForStartup,
      id,
      profilePic,
      wantsSkills,
      firstName,
      hasSkills,
      location,
      ideaIndustry,
      hoursPerWeekAvailable,
      ideaStage,
      hasValidCoFounderSubscription,
      addedBy,
      me,
      role,
      capability,
      longDescription,
      ideas = [],
    } = this.props
    const { tab } = this.state
    return (
      <div className="additional-details">
        <div className="additional-details__inner">
          <div className="additional-details__personal-details scroller">
            <div className="pattern" />
            <div className="additional-details__personal-details__content">
              <Link href="/profile/[id]" as={`/profile/${id}`}>
                <a>
                  <ProfilePic profilePic={profilePic} width={74} height={74} />
                </a>
              </Link>
              <div className="additional-details__name">
                <h2>{firstName}</h2>
                {hasValidCoFounderSubscription && (
                  <PremiumBadge
                    copy="Pro user"
                    showUpgradeHoverMessage={false}
                  />
                )}
                {me && (
                  <AddUser
                    userId={id}
                    isAlreadyAdded={addedBy?.length > 0}
                    loggedInUserId={me.id}
                  />
                )}
              </div>
              <div className="additional-details__from">
                <p>{location}</p>
              </div>
              {role == ROLE.cofounder && (
                <>
                  <div className="additional-details__has-skills">
                    <p>Has skills:</p>
                    {hasSkills.map((skill) => (
                      <Tag key={skill.id} label={skill.label} />
                    ))}
                  </div>
                  <div className="additional-details__wants-skills">
                    <p>Wants skills:</p>
                    {wantsSkills.map((skill) => (
                      <Tag key={skill.id} label={skill.label} />
                    ))}
                  </div>
                </>
              )}
              {role == ROLE.vendor && (
                <>
                  <div className="additional-details__has-skills">
                    <p>Industry:</p>
                    <Tag label={ideaIndustry.label} />
                  </div>
                  <div className="additional-details__wants-skills">
                    <p>Capability:</p>
                    <Tag label={capability.label} />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="additional-details__content-wrap scroller">
            {role === ROLE.cofounder && (
              <div className="additional-details__tabs">
                {hasIdeaForStartup && (
                  <div
                    className={classNames(
                      "additional-details__tab additional-details__tab--idea",
                      {
                        "additional-details__tab--active":
                          tab === ELEVATOR_PITCH_FOR_STARTUP,
                      }
                    )}
                  >
                    <button
                      onClick={() => this.setTab(ELEVATOR_PITCH_FOR_STARTUP)}
                    >
                      My Idea
                    </button>
                  </div>
                )}
                {(lookingToJoinStartupAsFounder || hasIdeaForStartup) && (
                  <div
                    className={classNames(
                      "additional-details__tab additional-details__tab--skills",
                      {
                        "additional-details__tab--active":
                          tab === WHY_MAKE_GOOD_COFOUNDER,
                      }
                    )}
                  >
                    <button
                      onClick={() => this.setTab(WHY_MAKE_GOOD_COFOUNDER)}
                    >
                      Why partner with me
                    </button>
                  </div>
                )}
              </div>
            )}
            <div className="additional-details__content">
              {tab === WHY_MAKE_GOOD_COFOUNDER && role == ROLE.cofounder && (
                <ReactCSSTransitionGroup
                  transitionName="overlay"
                  transitionAppear={true}
                  transitionAppearTimeout={500}
                  transitionEnter={false}
                  transitionLeave={false}
                >
                  <div className="additional-details__content__inner">
                    <ReactMarkdown
                      source={whyMakeGoodCofounder}
                      escapeHtml={false}
                      renderers={customRendererLink}
                    />
                    {hoursPerWeekAvailable && (
                      <div className="additional-details__contribution">
                        <strong>Capacity:</strong> {firstName} can contribute{" "}
                        <strong>{hoursPerWeekAvailable.label}</strong>.
                      </div>
                    )}
                  </div>
                </ReactCSSTransitionGroup>
              )}
              {tab === ELEVATOR_PITCH_FOR_STARTUP &&
                role == ROLE.cofounder &&
                ideas.map((data) => (
                  <ReactCSSTransitionGroup
                    transitionName="overlay"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={false}
                  >
                    <article
                      className="user-tile"
                      style={{ marginTop: "10px" }}
                    >
                      <div className="user-tile__inner">
                        <div className="userBox">
                          <div className="userImage">
                            <img
                              style={{ minWidth: "54px" }}
                              className=""
                              width="54"
                              height="49"
                              src={"/static/icons/ideabulb.svg"}
                            />
                          </div>
                          <div className="userContent">
                            <div className="userLink">
                              <Link href="/ideas/[id]" as={`/ideas/${data.id}`}>
                                <a className="usertitle">{data.title}</a>
                              </Link>
                            </div>
                            <div className="userButton">
                              <div className="user-tile__tags">
                                {data?.ideaStage && (
                                  <Tag
                                    className="industrybtn"
                                    key={data?.ideaStage?.id}
                                    label={data?.ideaStage?.label}
                                    title={data?.ideaStage?.label}
                                  />
                                )}
                              </div>
                              <div className="user-tile__tags">
                                {data?.ideaIndustry && (
                                  <Tag
                                    className="customecolor"
                                    key={data?.ideaIndustry?.id}
                                    title={data?.ideaIndustry?.label}
                                    label={data?.ideaIndustry?.label}
                                  />
                                )}
                              </div>
                              {me?.id && (
                                <Mutation mutation={SAVE_IDEA}>
                                  {(toggleSaveIdea) => (
                                    <div className="SaveBox">
                                      <Cta
                                        className={`saveButton ${
                                          data?.saves?.find(
                                            (e) => e?.user?.id === me?.id
                                          )?.id
                                            ? "active-save__btn"
                                            : ""
                                        }`}
                                        type="button"
                                        tag="button"
                                        text={
                                          <>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: "10px",
                                                alignItems: "center",
                                              }}
                                            >
                                              <div className="iconImg">
                                                <img src="/static/icons/bookmark.svg" />
                                              </div>
                                              <span className="saveButtonText">
                                                Save
                                              </span>
                                            </div>
                                          </>
                                        }
                                        bgColor="white"
                                        onClick={() =>
                                          toggleSaveIdea({
                                            variables: {
                                              ideaId: data?.id,
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                  )}
                                </Mutation>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="elevator-pitch">
                          <div className="user-tile__why-make">
                            {data?.elevatorPitch && (
                              <>
                                <strong>Elevator Pitch:</strong>
                                <ReactMarkdown
                                  source={
                                    data?.elevatorPitch.length < 100
                                      ? data?.elevatorPitch.replace(
                                          /<br \/>/g,
                                          " "
                                        )
                                      : `${data?.elevatorPitch
                                          .replace(/<br \/>/g, " ")
                                          .substring(0, 100)
                                          .trim()}...`
                                  }
                                  escapeHtml={false}
                                  renderers={customRendererLink}
                                />
                              </>
                            )}
                          </div>
                          <div className="user-chaticone">
                            <div className="userchaticonebox">
                              <img
                                src="/static/icons/message-dark.svg"
                                width={20}
                                height={20}
                              />
                              {data?.totalComments || 0}
                              <Mutation mutation={UPDATE_IDEAS_LIKES}>
                                {(toggleSaveIdea) => (
                                  <>
                                    <img
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        if (me?.id) {
                                          toggleSaveIdea({
                                            variables: {
                                              ideaId: data?.id,
                                            },
                                          })
                                        }
                                      }}
                                      src={`${
                                        data?.likes?.find(
                                          (e) => e?.user?.id === me?.id
                                        )?.id
                                          ? "/static/icons/heart-red.svg"
                                          : "/static/icons/hard.svg"
                                      }`}
                                      width={20}
                                      height={20}
                                    />{" "}
                                    {data?.totalLikes || 0}
                                  </>
                                )}
                              </Mutation>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </ReactCSSTransitionGroup>
                ))}

              {role == ROLE.vendor && (
                <ReactCSSTransitionGroup
                  transitionName="overlay"
                  transitionAppear={true}
                  transitionAppearTimeout={500}
                  transitionEnter={false}
                  transitionLeave={false}
                >
                  <div className="additional-details__content__inner">
                    <div className="additional-details__idea-details">
                      <strong>About vendor</strong>
                      <p>
                        {firstName} belongs to{" "}
                        <strong>{ideaIndustry?.label}</strong> industry.
                      </p>
                    </div>
                    <ReactMarkdown
                      source={longDescription}
                      escapeHtml={false}
                      renderers={customRendererLink}
                    />
                    <div className="additional-details__contribution"></div>
                  </div>
                </ReactCSSTransitionGroup>
              )}
            </div>
          </div>
        </div>
        <div className="additional-details__message">
          <SendMessage
            id={id}
            profilePic={profilePic}
            firstName={firstName}
            isCtaButton
          />
        </div>
      </div>
    )
  }
}

AdditionalDetails.propTypes = {}

export default AdditionalDetails
